import React, { useState } from 'react';
import {
  Grid, Paper, Typography, TextField, Button,
  FormControlLabel, RadioGroup, Radio, Box
} from '@mui/material';
import axios from 'axios';
import { API_URL } from '../../api';
import { useEffect } from 'react';
import CabecalhoProjeto from '../components/CabecalhoProjeto';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';





const AcoesANP = (props) => {
  const [avaliacao, setAvaliacao] = useState([]);
  const [status, setStatus] = useState('');
  const [sintomas, setSintomas] = useState(['']);
  const [causas, setCausas] = useState(['']);
  const [solucoes, setSolucoes] = useState(['']);
const [responsavel, setResponsavel] = useState(['']);


const [prazo, setPrazo] = useState(['']);
const [datasOcorrencia, setDatasOcorrencia] = useState(['']);


  
const processo = typeof props.processo === 'string'
  ? props.processo.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
  : '';

const anpSelecionada = props.anpSelecionada || {};
const anpId = anpSelecionada?.id || '';
console.log('✅ anpId capturado:', anpId); // Adicione isso pra validar


const dadosCabecalho = {
  ...anpSelecionada?.cabecalho,
  nomeCliente: anpSelecionada?.nomeCliente || '',
  codigoIM: anpSelecionada?.codigoIM || '',
  codigoCV: anpSelecionada?.codigoCV || '',
  op: anpSelecionada?.op || '',
  descricaoProduto: anpSelecionada?.descricaoProduto || ''
};





const [acoesSalvas, setAcoesSalvas] = useState({});

useEffect(() => {
  async function carregarTodasAcoes() {
    const processoNormalizado = processo.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    try {
      const res = await axios.get(`${API_URL}/anp/acoes/${anpId}/${processoNormalizado}`);
      const dadosAtuais = res.data;

      if (dadosAtuais) {
let sintomasSalvos = [''];
let causasSalvas = [''];
let solucoesSalvas = [''];

try {
  sintomasSalvos = JSON.parse(dadosAtuais.sintomas || '[""]');
} catch (e) {
  console.warn('❌ Erro ao parsear sintomas:', dadosAtuais.sintomas);
}

try {
  causasSalvas = JSON.parse(dadosAtuais.causas || '[""]');
} catch (e) {
  console.warn('❌ Erro ao parsear causas:', dadosAtuais.causas);
}

try {
  solucoesSalvas = JSON.parse(dadosAtuais.solucoes || '[""]');
} catch (e) {
  console.warn('❌ Erro ao parsear solucoes:', dadosAtuais.solucoes);
}


        const maior = Math.max(sintomasSalvos.length, causasSalvas.length, solucoesSalvas.length);
        const ajustarTamanho = (lista) => {
          const nova = [...lista];
          while (nova.length < maior) nova.push('');
          return nova;
        };

        setSintomas(ajustarTamanho(sintomasSalvos));
        setCausas(ajustarTamanho(causasSalvas));
        setSolucoes(ajustarTamanho(solucoesSalvas));



        // Garante alinhamento dos arrays adicionais
const maiorTamanho = sintomasSalvos.length;
const padArray = (arr) => {
  const novo = [...arr];
  while (novo.length < maiorTamanho) novo.push('');
  return novo;
};

setResponsavel(padArray(responsavel));
setPrazo(padArray(prazo));
setDatasOcorrencia(padArray(datasOcorrencia));

console.log('📊 Arrays após padronização:', {
  sintomas,
  causas,
  solucoes,
  responsavel,
  prazo,
  datasOcorrencia
});



try {
  setAvaliacao(JSON.parse(dadosAtuais.avaliacao || '[]'));
} catch (e) {
  console.warn('❌ Erro ao parsear avaliacao:', dadosAtuais.avaliacao);
  setAvaliacao([]);
}

try {
  setResponsavel(JSON.parse(dadosAtuais.responsavel || '[""]'));
} catch (e) {
  console.warn('❌ Erro ao parsear responsavel:', dadosAtuais.responsavel);
  setResponsavel(['']);
}

try {
  setPrazo(JSON.parse(dadosAtuais.prazo || '[""]'));
} catch (e) {
  console.warn('❌ Erro ao parsear prazo:', dadosAtuais.prazo);
  setPrazo(['']);
}

try {
  const parsed = JSON.parse(dadosAtuais.dataOcorrencia || '[""]');
  setDatasOcorrencia(Array.isArray(parsed) ? parsed : [parsed]);
} catch (e) {
  console.warn('⚠️ Erro ao parsear dataOcorrencia:', e);
  setDatasOcorrencia([dadosAtuais.dataOcorrencia]);
}

      }
    } catch (err) {
      console.error('Erro ao carregar ações salvas:', err);
    }
  }

  carregarTodasAcoes();
}, [anpId, processo]);




  const renderListaComAdicao = (titulo, lista, setLista, placeholder) => (
    <Box mb={3}>
      <Typography variant="subtitle1">{titulo}</Typography>
      {lista.map((item, idx) => (
        <TextField
          key={idx}
          fullWidth
          multiline
          minRows={3}
          value={item}
          onChange={(e) => {
            const novaLista = [...lista];
            novaLista[idx] = e.target.value;
            setLista(novaLista);
          }}
          placeholder={placeholder}
          sx={{ mb: 1 }}
        />
      ))}
      <Button onClick={() => {
        setLista([...lista, '']);
        if (titulo === 'Situação') setAvaliacao([...avaliacao, '']);
      }}>+ Adicionar outra {titulo.toLowerCase()}</Button>
    </Box>
  );

const handleSalvar = async () => {
const payload = {
  processo,
  dataOcorrencia: JSON.stringify(datasOcorrencia.map(d => d?.trim()).filter(Boolean)),
  sintomas: (sintomas || []).filter(s => s !== undefined && s !== null),
  causas: (causas || []).filter(c => c !== undefined && c !== null),
  solucoes: (solucoes || []).filter(s => s !== undefined && s !== null),
  status: status ?? '',
  avaliacao: Array.isArray(avaliacao) ? avaliacao : [],
  responsavel: (responsavel || []).filter(r => r !== undefined && r !== null),
  prazo: (prazo || []).filter(p => p !== undefined && p !== null),
  anpId
};


console.log('📦 Payload a ser enviado:', payload);


  try {
    const resposta = await axios.post(`${API_URL}/anp/salvar-acoes`, payload);
    console.log('🔁 Resposta do backend:', resposta.data);
    alert('Dados salvos com sucesso!');

    // 🔄 Após salvar, recarrega todas as ações da ANP
    const processoNormalizado = props.processo
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/\s|-/g, "_")
  .toLowerCase();

try {
  const resAtualizado = await axios.get(`${API_URL}/anp/acoes/${anpId}/${processoNormalizado}`);
  const dadosAtuais = resAtualizado.data;
  console.log("📥 Dados atualizados recebidos:", dadosAtuais);


  if (dadosAtuais) {
    setAcoesSalvas({ [processo]: dadosAtuais });

    if (dadosAtuais.processo) {
      setAcoesSalvas({ [dadosAtuais.processo]: dadosAtuais });
    }
  }
} catch (erroRecarregar) {
  console.warn('⚠️ Nenhuma ação encontrada após salvar (pode ser primeira vez):', erroRecarregar.message);
  // Mesmo sem resposta do back, mantém dados em memória
  setAcoesSalvas((prev) => ({
    ...prev,
    [processo]: {
      processo,
      sintomas: sintomas.filter(s => !!s),
      causas: causas.filter(c => !!c),
      solucoes: solucoes.filter(s => !!s),
      dataOcorrencia: JSON.stringify(datasOcorrencia.filter(d => !!d)),
      responsavel: responsavel.filter(r => !!r),
      prazo: prazo.filter(p => !!p),
      avaliacao,
      status
    }
  }));
}



  } catch (err) {
    console.error('Erro ao carregar ações salvas:', err?.response?.data || err.message);
    alert('Erro ao salvar.');
    console.error(err);
  }
};



return (
  <>
    <CabecalhoProjeto dados={dadosCabecalho} editavel={false} mostrarCabecalhoCompleto={false} />






   
{sintomas.map((_, idx) => (
  <Box key={idx} sx={{ 
    mb: 4, 
    p: 2, 
    border: '1px solid #ccc', 
    borderRadius: 2, 
    position: 'relative' 
  }}>
    <Button
      size="small"
      variant="contained"
      color="error"
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
        minWidth: 'auto',
        px: 1.5,
        py: 0.5,
        fontSize: '0.75rem',
        fontWeight: 'bold',
        color: 'white',
        backgroundColor: '#d32f2f',
        '&:hover': {
          backgroundColor: '#b71c1c',
        }
      }}
      onClick={() => {
        const removerItem = (arr) => arr.filter((_, i) => i !== idx);
        setSintomas(removerItem);
        setCausas(removerItem);
        setSolucoes(removerItem);
        setResponsavel(removerItem);
        setPrazo(removerItem);
        setDatasOcorrencia(removerItem);
      }}
    >
      X
    </Button>

    <Typography variant="h6" gutterBottom>Situação {idx + 1}</Typography>




<TextField
  fullWidth
  label={`Data da Ocorrência ${idx + 1}`}
  type="date"
  InputLabelProps={{ shrink: true }}
value={datasOcorrencia[idx] || ''}
onChange={(e) => {
  const novo = [...datasOcorrencia];
  novo[idx] = e.target.value;
  setDatasOcorrencia(novo);
}}

  sx={{ mb: 2 }}
/>



    <TextField
      fullWidth
      multiline
      minRows={3}
      value={sintomas[idx]}
      onChange={(e) => {
        const nova = [...sintomas];
        nova[idx] = e.target.value;
        setSintomas(nova);
      }}
      placeholder="Descreva a situação..."
      sx={{ mb: 2 }}
    />
    <Typography variant="subtitle1">Causa Raiz {idx + 1}</Typography>
    <TextField
      fullWidth
      multiline
      minRows={3}
      value={causas[idx] || ''}
      onChange={(e) => {
        const nova = [...causas];
        nova[idx] = e.target.value;
        setCausas(nova);
      }}
      placeholder="Descreva a causa raiz..."
      sx={{ mb: 2 }}
    />
    <Typography variant="subtitle1">Soluções Propostas {idx + 1}</Typography>
<TextField
  fullWidth
  multiline
  minRows={3}
  value={solucoes[idx] || ''}
  onChange={(e) => {
    const nova = [...solucoes];
    nova[idx] = e.target.value;
    setSolucoes(nova);
  }}
  placeholder="Descreva a solução..."
  sx={{ mb: 2 }}
/>

<Grid container spacing={2} sx={{ mb: 2 }}>
  <Grid item xs={12} sm={6}>
<TextField
  fullWidth
  label={`Responsável pelas Ações ${idx + 1}`}
  value={responsavel[idx] || ''}
  onChange={(e) => {
    const novo = [...responsavel];
    novo[idx] = e.target.value;
    setResponsavel(novo);
  }}
/>

  </Grid>
  <Grid item xs={12} sm={6}>
    <TextField
      fullWidth
      label={`Prazo para Conclusão ${idx + 1}`}
      type="date"
      InputLabelProps={{ shrink: true }}


value={prazo[idx] || ''}
inputProps={{ pattern: "\\d{4}-\\d{2}-\\d{2}" }}
onChange={(e) => {
  const novo = [...prazo];
  novo[idx] = e.target.value;
  setPrazo(novo);
}}



    />
  </Grid>
</Grid>

    
  </Box>
))}




<Box mt={2} mb={4}>
  <Button
    onClick={() => {
setSintomas([...sintomas, '']);
setCausas([...causas, '']);
setSolucoes([...solucoes, '']);
setResponsavel([...responsavel, '']);
setDatasOcorrencia([...datasOcorrencia, '']);
setPrazo([...prazo, '']);



    }}
    variant="outlined"
  >
    + Adicionar Situação
  </Button>
</Box>




<Box mt={4} display="flex" justifyContent="center" gap={2}>
  <Button variant="contained" color="primary" size="large" onClick={handleSalvar}>
    Salvar Ações
  </Button>
  <Button onClick={props.onFechar} variant="outlined" color="secondary" size="large">
    ❌ Fechar
  </Button>
</Box>




  </>
);



};





export default AcoesANP;